import React from 'react'

import { ReactComponent as CreditBanner02 } from "assets/images/icons/creditsuccess.svg";

const CreditApplicationEligible = () => {
  return (
    <div className="flex justify-center items-center">
        <div className="relative w-[559px] bg-[#FFFFFF] h-full p-[22px] rounded-lg">
            <div className="bg-[#FFF2E1] rounded-lg">
                <CreditBanner02 />
            </div>

            <div className="font-aeonik text-[20px] font-bold leading-7 text-center my-2">
                <div>Congratulations! Your business is eligible for <br/> an Earnipay Loan</div>
            </div>

            <div className="font-thin text-[16px] text-center">
                Please note that your business relationship manager will reach out to you shortly to initiate the loan request process
            </div>

            <div className="font-aeonik text-[#4A5564] bg-[#E5E7EB] font-bold text-lg leading-7 text-center p-8 mt-[48px] rounded-lg">
                If you have any questions or feedback please reach out to sales@earnipay.com
            </div>
        </div>
    </div>
  )
}

export default CreditApplicationEligible